import React from 'react'
import SupportCenter from '@merchant-backend/support-center/src/index'
import Header from '@components/LocalMerchant/Header'
import style from './style.module.less'

// 再包一层的目的是为了加上统一的Header
const SupportCenterMain = ({ children }) => {
  return (
    <>
      <div className={style.header}>
        <Header banTopBanner />
      </div>
      <SupportCenter>{children}</SupportCenter>
    </>
  )
}

export default SupportCenterMain
